import {
	SET_FORM_STATE,
	GET_DUMPS_UPDATE
} from '../actions/ConfigurationActions.js';

const initialState = {
	dumps: [],
	formState: { nokia: {
		isValid: false,
		values: {
			inputType: 'file'
		},
		touched: { },
		errors: { }
	},
	huawei: {
		isValid: false,
		values: {
			inputType: 'file'
		},
		touched: {},
		errors: {}
	},
	},
};

const configurationReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					case GET_DUMPS_UPDATE: {
						return {
							...state,
							dumps: action.dumpsUpdate
						};
					}
					default: {
						return state;
					}
	}
};

export default configurationReducer;
